
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { useEffect } from "react";

//Components
import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';

//Actions
import {
    clearRedux,
    dashboardPanelDeleteRequest,
    dashboardPanelSearchRequest,
} from 'Redux/actions';

//Styles
import './index.scss'

const DeleteDashboard = (props) => {
    const { setDashboardSelected, setEditMode } = props
    const { messages } = useIntl();

    const dispatch = useDispatch();

    //Redux States
    const {
        openModal,
        panel,
        loading,
        result
    } = useSelector(state => state.deleteDashboardRedux);

    const closeModal = () => {
        dispatch(clearRedux("DASHBOARD_PANEL_DELETE"))
    }

    const applyChanges = () => {
        dispatch(dashboardPanelDeleteRequest(panel?.id))
    }

    useEffect(() => {
        if (result?.result) {
            NotificationManager.success(
                messages['delete_dashboard_success_message'],
                messages['delete_dashboard_title'],
                3000,
            );
            setEditMode(false)
            setDashboardSelected({})
            dispatch(dashboardPanelSearchRequest())
            closeModal()
        }
    }, [result])

    return (
        <Modal
            open={openModal}
            title={panel?.name && `${messages['delete_dashboard_title']} ${panel?.name}`}
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
            size="small"
        >
            <ModalBody>
                <div className="delete-dashboard-modal">
                    <label>{messages['delete_dashboard_descripcion']}</label>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['common_cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => applyChanges()}
                >
                    {messages['delete']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default DeleteDashboard;